<form [formGroup]="form" (submit)="onSubmit($event)">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content class="mat-typography">
    <h4>{{ data.message }}</h4>
    <div class="block pb-2">
      <input
        type="text"
        class="lum-input"
        [ngClass]="{ 'text-uppercase': !data.isCaseSensitive }"
        matInput
        formControlName="inputValue"
      />
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      mat-button
      type="submit"
      [disabled]="form.invalid"
      class="lum-button lum-button--danger lum-button--medium mx-1"
      >{{ this.data.deleteButtonText }}</button
    >
  </mat-dialog-actions>
</form>
